import React from "react";

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-card">
        <h1>
          Hi, I'm <span>Peesa Lahari Sri</span>
        </h1>
        <p>AI/ML Developer | Full Stack Developer | Problem Solver</p>
      </div>
    </section>
  );
};

export default Hero;